export function readChannelIdFromUrl(): number | null {
  try {
    const raw = new URLSearchParams(window.location.search).get('channel')
    if (!raw) return null
    const parsed = parseInt(raw, 10)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function isKioskChannelFromUrl(): boolean {
  return readChannelIdFromUrl() === 3
}
